import { FaCheckCircle } from "react-icons/fa";
import showcaseImg from "../../images/showcaseimg.png";
import avocadoImg from "../../images/avocado.png";
import lemonImg from "../../images/lemon.png";
import listochekImg from "../../images/listochek.png";
import { Link } from "react-scroll";

import "./showcase.scss";

const Showcase = () => {
  return (
    <section className="showcase">
      {/* Листья и фон */}
      <img src={listochekImg} alt="лист" className="leaf leaf-top-left" />
      <img src={listochekImg} alt="лист" className="leaf leaf-top-right" />
      <img src={listochekImg} alt="лист" className="leaf leaf-bottom-left" />
      <img src={listochekImg} alt="лист" className="leaf leaf-bottom-right" />
      <img src={listochekImg} alt="лист" className="leaf leaf-middle-left" />
      <img src={listochekImg} alt="лист" className="leaf leaf-middle-right" />
      <img src={lemonImg} alt="Лимон" className="lemon-bg" />

      <div className="showcase-content">
        {/* Левая часть */}
        <div className="showcase-left">
          <h1>
            <span className="highlight">КУРС</span> очищения организма{" "}
            <span className="highlight">НА СОКАХ</span>
          </h1>

          {/* Обертка: список + кнопка */}
          <div className="features-wrapper">
            <ul className="features">
              <li>
                <div className="icon-wrapper">
                  <FaCheckCircle />
                </div>
                Минус 1 кг за 1 день
              </li>
              <li>
                <div className="icon-wrapper">
                  <FaCheckCircle />
                </div>
                Чистая кожа
              </li>
              <li>
                <div className="icon-wrapper">
                  <FaCheckCircle />
                </div>
                Готовить не нужно – доставим соки домой
              </li>
            </ul>

            {/* 🔥 Кнопка со скроллом */}
            <Link
              to="programs"
              spy={true}
              smooth={true}
              offset={-80}
              duration={800}
              className="cta-btn"
            >
              Выбрать программу
            </Link>
          </div>
        </div>

        {/* Правая часть */}
        <div className="showcase-right">
          <img src={showcaseImg} alt="Showcase" className="main-img" />
          <img src={avocadoImg} alt="Avocado" className="avocado" />
        </div>
      </div>
    </section>
  );
};

export default Showcase;